export const UPDATE_VIEW_PADDING = 'UPDATE_VIEW_PADDING';

export const updateViewPadding = padding => {
  return {
    type: UPDATE_VIEW_PADDING,
    data: padding
  }
}

//Not all app state is stored in redux, it's needed to shoot redux change event in order to make cahnges in components according to old state 
export const reloadState = () => {
  return {
    type: UPDATE_VIEW_PADDING,
    data: Math.random()
  }
}

export const PAN_ZOOM = 'PANZOOM';
export const panZoom = data => {
  return {
    type: PAN_ZOOM,
    data
  };
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/actions.js